import { useState } from "react";
import { useIntl } from "react-intl";
import EditableOption from "~/components/molecules/EditableOption/EditableOption";
import DiscountModalNew from "../DiscountModal/DiscountModalNew";

type EditableDiscountProps = {
  showDiscountedAmount?: boolean;
  discountPercent?: string;
  discountTotal?: number;
  editable?: boolean;
  hasFreeProducts?: boolean;
};

const EditableDiscount = ({
  discountPercent,
  discountTotal,
  showDiscountedAmount,
  editable = true,
  hasFreeProducts = false,
}: EditableDiscountProps) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const showModal = () => setOpen(true);

  return (
    <div>
      <DiscountModalNew open={open} setOpen={setOpen} />
      <EditableOption
        editable={editable}
        onClick={showModal}
        title={
          hasFreeProducts
            ? intl.formatMessage({ id: "discount.modal.freeProducts" })
            : showDiscountedAmount
              ? intl.formatMessage(
                  {
                    id: "pricing.card.discountValue",
                  },
                  {
                    percent: discountPercent,
                    amount: discountTotal,
                  }
                )
              : intl.formatMessage({ id: "field.empty" })
        }
        className={showDiscountedAmount ? "text-black" : "text-grey-400"}
      />
    </div>
  );
};

export default EditableDiscount;
